const Category = () =>
  import(
    /* webpackChunkName: "base-info-contract-category" */ '@/pages/base-info/contract/category/index.vue'
  )
const CreateCategory = () =>
  import(
    /* webpackChunkName: "base-info-contract-category" */ '@/pages/base-info/contract/category/create.vue'
  )
const EditCategory = () =>
  import(
    /* webpackChunkName: "base-info-contract-category" */ '@/pages/base-info/contract/category/edit.vue'
  )

export default {
  path: 'category',
  meta: {
    label: 'contractCategory',
    auth: 'category'
  },
  component: {
    name: 'Category',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BaseInfoContractCategory',
      path: '/',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Category
    },
    {
      name: 'BaseInfoCreateContractCategory',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateCategory
    },
    {
      name: 'BaseInfoEditContractCategory',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditCategory,
      props: true
    }
  ]
}
